import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {DocumentService} from '../../../../../../../core/services/document.service';
import ProfessionList from '../../../../../../../../assets/JSON/profession-list.json';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {ocrInfo} from '../../../../../../../core/ek-e-commerce/ek-models/document-ocr-information';
import {
    forbiddenProvinceValidator,
    Wilaya,
    WilayaService
} from '../../../../../../../core/ek-e-commerce/ek-services/wilaya.service';
import {Town} from '../../../../../../../core/ek-e-commerce/ek-models/town';
import {map, startWith, take} from 'rxjs/operators';
import {BehaviorSubject, Observable} from 'rxjs';
import {ClientModel} from '../../../../../../../core/ek-e-commerce/ek-models/client.model';
import {TownService} from '../../../../../../../core/ek-e-commerce/ek-services/town.service';
import {
    ClientOcrInformationService
} from '../../../../../../../core/ek-e-commerce/ek-services/clientOcrInformation.service';
import {SocialProfessional} from '../../../../../../../core/ek-e-commerce/ek-models/social-professional';
import {DecimalFormatPipe} from '../../../../../../../core/_base/layout';
import {FoldersService} from '../../../../../../../core/ek-e-commerce/ek-services/folders.service';
import {MatDatepicker} from '@angular/material/datepicker';
import {ActivityTranslatePipe} from '../../../../../../../core/_base/layout/pipes/domain-translate.pipe';
import {ProfessionTranslatePipe} from '../../../../../../../core/_base/layout/pipes/profession-translate.pipe';
import {BANK_LENDER} from '../../../../Shared/Constants/bank.lender';
import {FormsValidationService} from '../../../../Shared/services/forms-validation.service';
import Keyboard from "simple-keyboard";
import layout from "simple-keyboard-layouts/build/layouts/arabic";
import {FolderVerificationService} from "../../../../../../../core/services/folder-verification.service";

export interface List {
    name: string;
    value: string;
}

@Component({
    selector: 'kt-folder-step-three',
    templateUrl: './folder-step-three.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./folder-step-three.component.scss'],
    providers: [DecimalFormatPipe, ProfessionTranslatePipe, ActivityTranslatePipe]
})
export class FolderStepThreeComponent implements OnInit {

    @Input() ocrInfos!: ocrInfo;
    @Input() client: ClientModel;
    @Input() idFolder: number;
    @Output() clientInfoForm = new EventEmitter<FormGroup>();
    @Input() needSomeChanges: boolean;

    professions = ProfessionList;

    panelOpenState = false;
    panelOpenState0 = false;
    panelOpenState1 = false;
    panelOpenState2 = false;
    professionalClientCategory = '';
    socialClientCategory = '';
    selectedWilaya = '';
    form!: FormGroup;
    public wilayasList: Wilaya[] = [];
    public birthWilayasList: Wilaya[] = [];
    public employerWilayasList: Wilaya[] = [];
    socialProfessionalInfo: SocialProfessional;


    wilayaSubject$ = new BehaviorSubject<string>('');
    readonly loadingWilaya$ = this.wilayaSubject$.asObservable();

    townsSubject$ = new BehaviorSubject<Town[]>([]);
    readonly town$ = this.townsSubject$.asObservable();

    private PHONE_REGEX = /^(00213|\+213|0)(5|6|7)(\s*?[0-9]\s*?){5,8}$/;
    private SPEC_CHAR_REGEX = '^[\\x20-\\x7E]*$';

    wilaya = '';
    currentRole = '';
    public towns: Town[] = [];
    filteredOptions: Observable<Wilaya[]>;
    filteredEmployerWilaya: Observable<Wilaya[]>;
    townFilteredOptions: Observable<Town[]>;
    activityDomainOptions: Observable<List[]>;
    activityDomainTwoOptions: Observable<List[]>;
    professionOptions: Observable<List[]>;
    bankLenderCreditOtherOptions: Observable<List[]>;
    carLoanLenderBankOptions: Observable<List[]>;
    mortgageLenderBankOptions: Observable<List[]>;

    folderState = '';

    persoSituList = [
        {name: 'Célibataire', value: 'SINGLE'},
        {name: 'Marié', value: 'MARRIED'},
        {name: 'Divorcé', value: 'DIVORCE'},
        {name: 'Veuf', value: 'WIDOWER'}
    ];

    // type EducationalLevel = 'LESS_THAN_HIGH_SCHOOL' | 'SECONDARY_LEVEL' | 'BACHELOR' | 'UNIVERSITY';
    instructionTypeList = [
        {name: 'Moins que le niveau secondaire', value: 'LESS_THAN_HIGH_SCHOOL'},
        {name: 'Niveau secondaire', value: 'SECONDARY_LEVEL'},
        {name: 'Bachelier', value: 'BACHELOR'},
        {name: 'Universitaire', value: 'UNIVERSITY'}
    ];

    genderList = [
        {name: 'Homme', value: 'Male'},
        {name: 'Femme', value: 'Female'},
    ];

    accountTypeList = [
        {name: 'CCP', value: 'CCP'},
        {name: 'BANQUE', value: 'BANK'},
        {name: 'BANQUE ALSALAM ', value: 'BANKASBA'},
    ];

    habiTypeList = [
        {name: 'Avec les parents', value: 'WITH_PARENTS'},
        {name: 'Propriétaire', value: 'OWNER'},
        {name: 'Logement de fonction', value: 'FUNCTIONAL_ACCOMMODATION'},
        {name: 'Location', value: 'LEASE'},
    ];

    profSituList = [
        {name: 'Retraité militaire', value: 'MILITARY_RETIRED'},
        {name: 'Employé', value: 'EMPLOYEE'},
        {name: 'Retraité', value: 'RETRIED'},
        {name: 'Militaire', value: 'MILITARY'}
    ];

    typeContratList = [
        {name: 'Contrat de travail à durée indéterminée (CDI)', value: 'CDI'},
        {name: 'Contrat à durée déterminée (CDD)', value: 'CDD'},
        {name: 'Non Concerné', value: 'OTHER'},
    ];
    @ViewChild('datePicker00') datePicker00!: MatDatepicker<Date>;
    @ViewChild('otherCreditEndDateDP') otherCreditEndDateDP!: MatDatepicker<Date>;
    @ViewChild('otherRentCreditEndDateDP') otherRentCreditEndDateDP!: MatDatepicker<Date>;
    @ViewChild('carCreditEndDateDP') carCreditEndDateDP!: MatDatepicker<Date>;
    @ViewChild('mortgageEndDateDP') mortgageEndDateDP!: MatDatepicker<Date>;
    @ViewChild('deliveryDateDP') deliveryDateDP!: MatDatepicker<Date>;
    @ViewChild('validationDateDP') validationDateDP!: MatDatepicker<Date>;
    @ViewChild('recruitmentDateDP') recruitmentDateDP!: MatDatepicker<Date>;
    @ViewChild('dateRetraiteDP') dateRetraiteDP!: MatDatepicker<Date>;

    filteredBirthWilayas: Observable<Wilaya[]>;
    keyboard: Keyboard;
    keyboards: Keyboard[] = [];
    private ocrSbj$ = new BehaviorSubject<ocrInfo>(null);
    public ocrInfosObs$ = this.ocrSbj$.asObservable();
    showKeyboards: boolean[] = [];

    prevValue2: string[] = [];

    constructor(public documentService: DocumentService,
                public folderVerificationService: FolderVerificationService,
                private fb: FormBuilder,
                private wilayaService: WilayaService, private townService: TownService,
                private activityTranslatePipe: ActivityTranslatePipe, private professionTranslatePipe: ProfessionTranslatePipe,
                private clientOcrInformationService: ClientOcrInformationService,
                private decimalFormatPipe: DecimalFormatPipe,
                private folderService: FoldersService,
                private formsValidationService: FormsValidationService,
    ) {
        this.currentRole = JSON.parse(localStorage.getItem('currentUser')).roles;
    }

    ngOnInit(): void {
        // detect changes in client social information
        this.clientOcrInformationService.loadingSocialProfessionalSubject.subscribe(change => {
            if (change) {
                this.socialProfessionalInfo = change;
            }
        });

        this.folderService.folderStateSubj$.subscribe(state => this.folderState = state);

        this.wilayasList = this.wilayaService.getWilayasItems();
        this.birthWilayasList = this.wilayaService.getWilayasItems();
        this.employerWilayasList = this.wilayaService.getWilayasItems();


        this.documentService.ocrSubject.subscribe(res => {
            if (res) {
                this.ocrInfos = res;
                this.ocrSbj$.next(res);
                this.createClientOcrFormGrp();
            } else {
                this.ocrSbj$.next(null);
                this.createClientOcrFormGrp();
            }
        });

        this.town$.subscribe(town => {
            if (town.length > 0) {
                this.towns = town;
            }
        });
        this.showKeyboards.push(false);

    }

    openDatePicker(): void {
        if (this.datePicker00) {
            this.datePicker00.open();
        }
    }

    openOtherCreditEndDateDP(): void {
        if (this.otherCreditEndDateDP) {
            this.otherCreditEndDateDP.open();
        }
    }

    openOtherRentCreditEndDateDP(): void {
        if (this.otherRentCreditEndDateDP) {
            this.otherRentCreditEndDateDP.open();
        }
    }

    openCarCreditEndDateDP(): void {
        if (this.carCreditEndDateDP) {
            this.carCreditEndDateDP.open();
        }
    }

    openMortgageEndDateDP(): void {
        if (this.mortgageEndDateDP) {
            this.mortgageEndDateDP.open();
        }
    }

    opendeliveryDatePicker(): void {
        if (this.deliveryDateDP) {
            this.deliveryDateDP.open();
        }
    }

    openValidationDatePicker(): void {
        if (this.validationDateDP) {
            this.validationDateDP.open();
        }
    }

    openRecruitmentDatePicker(): void {
        if (this.recruitmentDateDP) {
            this.recruitmentDateDP.open();
        }
    }

    openDateRetraitePicker(): void {
        if (this.dateRetraiteDP) {
            this.dateRetraiteDP.open();
        }
    }

    toggleKeyboard(index: number) {
        this.showKeyboards[index] = !this.showKeyboards[index];

    }

    createClientOcrFormGrp() {

        this.socialClientCategory = this.ocrInfos ? this.ocrInfos?.personnelInformation?.socialClientCategory : '';
        this.professionalClientCategory = this.ocrInfos ? this.ocrInfos?.professionalSituation?.professionalClientCategory : '';

        this.form = this.fb.group({
            socialClientCategory: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.socialClientCategory : '', Validators.required],
            educationalLevel: [this.ocrInfos?.personnelSituation ? this.ocrInfos?.personnelSituation?.educationalLevel : '', Validators.required],
            dependentChild: [this.ocrInfos?.personnelSituation ? this.ocrInfos?.personnelSituation?.dependentChild : ''],
            dependentOtherPeople: [this.ocrInfos?.personnelSituation ? this.ocrInfos?.personnelSituation?.dependentOtherPeople : '', Validators.required],
            habitation: [this.ocrInfos?.personnelSituation ? this.ocrInfos?.personnelSituation?.habitation : '', Validators.required],
            zipCode: [this.ocrInfos?.personnelSituation ? this.ocrInfos?.personnelSituation?.zipCode : '', [this.formsValidationService.numericCharacters, Validators.minLength(5), Validators.maxLength(5)]],
            wilaya: new FormControl(this.ocrInfos?.informationAddress?.wilayaNameAscii ? this.ocrInfos?.informationAddress?.wilayaNameAscii : '', [forbiddenProvinceValidator(this.wilayasList), Validators.required]),
            address: [this.ocrInfos?.personnelSituation ? this.ocrInfos?.personnelSituation?.personnelSituationAddress : '', Validators.required],
            daira: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.daira : '', Validators.required],
            personnelSituationAddressAscii: [this.ocrInfos?.personnelSituation?.personnelSituationAddressAscii ? this.ocrInfos?.personnelSituation?.personnelSituationAddressAscii : '', Validators.compose([Validators.required, Validators.maxLength(34), Validators.pattern(this.SPEC_CHAR_REGEX)])],
            commune: new FormControl(this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.commune : '', [Validators.required, this.forbiddenTownsValidator()]),
            communeCode: new FormControl(this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.communeCode : '', [Validators.required, Validators.maxLength(5)]),
            wilayaNameAsciiInArabic: [this.ocrInfos?.informationAddress ? this.ocrInfos?.informationAddress?.wilayaNameAsciiInArabic : '', Validators.compose([Validators.required, Validators.minLength(2)])],
            communeNameAsciiInArabic: [this.ocrInfos?.informationAddress ? this.ocrInfos?.informationAddress?.communeNameAsciiInArabic : '', Validators.compose([Validators.required, Validators.minLength(2)])],
            lastName: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.lastName : '', Validators.compose([Validators.required, Validators.minLength(2), this.formsValidationService.alphabeticCharacters])],
            firstName: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.firstName : '', Validators.compose([Validators.required, Validators.minLength(2), this.formsValidationService.alphabeticCharactersWithHyphens])],
            motherLastName: [this.ocrInfos?.personnelInformation?.lastNameMother ? this.ocrInfos?.personnelInformation?.lastNameMother : '', Validators.compose([Validators.required, Validators.minLength(2), this.formsValidationService.alphabeticCharacters])],
            motherFirstName: [this.ocrInfos?.personnelInformation?.firstNameMother ? this.ocrInfos?.personnelInformation?.firstNameMother : '', Validators.compose([Validators.required, Validators.minLength(2), this.formsValidationService.alphabeticCharacters])],
            lastNameMotherInArabic: [this.ocrInfos?.personnelInformation?.lastNameMotherInArabic ? this.ocrInfos?.personnelInformation?.lastNameMotherInArabic : '', Validators.compose([Validators.required, Validators.minLength(2)])],
            firstNameMotherInArabic: [this.ocrInfos?.personnelInformation?.firstNameMotherInArabic ? this.ocrInfos?.personnelInformation?.firstNameMotherInArabic : '', Validators.compose([Validators.required, Validators.minLength(2)])],
            fatherFirstName: [this.ocrInfos?.personnelInformation?.firstNameFather ? this.ocrInfos?.personnelInformation?.firstNameFather : '', Validators.compose([Validators.required, Validators.minLength(2), this.formsValidationService.alphabeticCharacters])],
            firstNameFatherInArabic: [this.ocrInfos?.personnelInformation?.firstNameFatherInArabic ? this.ocrInfos?.personnelInformation?.firstNameFatherInArabic : '', Validators.compose([Validators.required, Validators.minLength(2)])],
            gender: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.gender : '', Validators.required],
            partnerLastName: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.partnerLastName : ''],
            maidenName: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.maidenName : ''],
            maidenNameInArabic: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.maidenNameInArabic : '', Validators.compose([Validators.minLength(2)])],
            lastNameEnArab: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.lastNameEnArab : '', Validators.required],
            fistNameEnArab: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.fistNameEnArab : '', Validators.required],
            placeOfBirth: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.placeOfBirth : '', Validators.compose([Validators.required, Validators.minLength(2), this.formsValidationService.alphabeticCharacters])],
            birthWilaya: new FormControl(this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.birthWilaya : '', forbiddenProvinceValidator(this.birthWilayasList)),
            placeOfBrithArabic: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.placeOfBrithArabic : '', Validators.required],
            codePlaceOfBirth: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.codePlaceOfBirth : '', Validators.required],
            cardType: ['', Validators.required],
            idCardNumber: [this.ocrInfos?.personnelInformation ? (this.ocrInfos?.personnelInformation?.idCardNumber ? this.ocrInfos?.personnelInformation?.idCardNumber : this.ocrInfos?.personnelInformation?.driverLicenceNumber) : '', Validators.required],
            deliveryDaira: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.deliveryDaira : '', Validators.required],
            nationalIdNumber: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.nationalIdNumber : '', Validators.compose([Validators.required, Validators.minLength(18), Validators.maxLength(18)])],
            socialSecurityNumber: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.socialSecurityNumber : ''],
            actOfBrithNumber: [this.ocrInfos?.personnelInformation ? this.ocrInfos?.personnelInformation?.actOfBrithNumber : '', Validators.compose([Validators.required])],
            greenCardDetail: [this.ocrInfos?.personnelInformation ? (this.ocrInfos?.personnelInformation?.greenCardDetail ? this.ocrInfos?.personnelInformation?.greenCardDetail : false) : false, Validators.required],
            professionalClientCategory: [this.ocrInfos?.professionalSituation ? this.ocrInfos?.professionalSituation?.professionalClientCategory : '', Validators.required],
            activityDomain: new FormControl(this.ocrInfos?.professionalSituation?.activityDomain ? this.activityTranslatePipe.transform(this.ocrInfos?.professionalSituation?.activityDomain) : '', Validators.required),
            activityDomainTwo: new FormControl(this.ocrInfos?.professionalSituation?.activityDomaineBank ? this.activityTranslatePipe.transform(this.ocrInfos?.professionalSituation?.activityDomaineBank) : '', Validators.required),
            profession: new FormControl(this.ocrInfos?.professionalSituation ? this.ocrInfos?.professionalSituation?.profession : '', Validators.required),
            professionalPhone: [this.ocrInfos?.professionalSituation ? this.ocrInfos?.professionalSituation?.professionalPhone : '', Validators.compose([Validators.minLength(10), Validators.pattern(this.PHONE_REGEX)])],
            contractType: [this.ocrInfos?.professionalSituation ? this.ocrInfos?.professionalSituation?.contractType : '', Validators.required],
            montant_net: [this.ocrInfos ? (this.ocrInfos?.professionalSituation?.salary ? this.decimalFormat(this.ocrInfos?.professionalSituation?.salary) : '') : ''],
            netSalaryRENA: [this.ocrInfos ? (this.ocrInfos?.professionalSituation?.netSalaryRENA ? this.decimalFormat(this.ocrInfos?.professionalSituation?.netSalaryRENA) : '') : ''],
            employer: [this.ocrInfos?.professionalSituation ? this.ocrInfos?.professionalSituation?.employer : ''],
            employerWilaya: [this.ocrInfos?.professionalSituation ? this.ocrInfos?.professionalSituation?.employerWilaya : '', [forbiddenProvinceValidator(this.employerWilayasList)]],
            employerAddress: [this.ocrInfos?.professionalSituation ? this.ocrInfos?.professionalSituation?.employerAddress : ''],
            accountType: [this.ocrInfos?.financialSituation ? this.ocrInfos?.financialSituation?.accountType : '', Validators.required],
            accountNumberCCP: [this.ocrInfos?.financialSituation ? this.ocrInfos?.financialSituation?.accountNumberCCP : '', Validators.maxLength(20)],
            accountNumberBank: [this.ocrInfos?.financialSituation ? this.ocrInfos?.financialSituation?.accountNumberBank : '', Validators.maxLength(10)],
            bankName: [this.ocrInfos?.financialSituation ? this.ocrInfos?.financialSituation?.bankName : ''],
            bankCode: [this.ocrInfos?.financialSituation ? this.ocrInfos?.financialSituation?.bankCode : '', Validators.maxLength(3)],
            agencyName: [this.ocrInfos?.financialSituation ? this.ocrInfos?.financialSituation?.agencyName : ''],
            agencyCode: [this.ocrInfos?.financialSituation ? this.ocrInfos?.financialSituation?.agencyCode : '', Validators.maxLength(5)],
            accountKey: [this.ocrInfos?.financialSituation ? this.ocrInfos?.financialSituation?.accountKey : '', Validators.compose([Validators.required, Validators.maxLength(2)])],
            accountNumber: [this.ocrInfos?.financialSituation ? this.ocrInfos?.financialSituation?.accountNumber : '', Validators.maxLength(10)],
            birthDay: [this.ocrInfos?.personnelInformation ? (this.ocrInfos?.personnelInformation?.birthDay ? this.formatDate_(this.ocrInfos?.personnelInformation?.birthDay) : '') : '', Validators.required],
            validationDate: [this.ocrInfos?.personnelInformation ? (this.ocrInfos?.personnelInformation?.validationDate ? this.formatDate_(this.ocrInfos?.personnelInformation?.validationDate) : '') : '', Validators.required],
            recruitmentDate: [this.ocrInfos?.professionalSituation ? (this.ocrInfos?.professionalSituation?.recruitmentDate ? this.formatDate_(this.ocrInfos?.professionalSituation?.recruitmentDate) : '') : ''],
            dateRetraite: [this.ocrInfos?.professionalSituation
                ? (this.ocrInfos?.professionalSituation?.professionalClientCategory === 'MILITARY_RETIRED'
                    ? (this.ocrInfos?.professionalSituation?.radiationRecruitmentDate ? this.formatDate_(this.ocrInfos?.professionalSituation?.radiationRecruitmentDate) : '')
                    : (this.ocrInfos?.professionalSituation?.retraitDate ? this.formatDate_(this.ocrInfos?.professionalSituation?.retraitDate) : ''))
                : ''],
            deliveryDate: [this.ocrInfos?.personnelInformation ? (this.ocrInfos?.personnelInformation?.deliveryDate ? this.formatDate_(this.ocrInfos?.personnelInformation?.deliveryDate) : '') : '', Validators.required],
            mortgageAmount: [this.ocrInfos?.financialSituation?.mortgageAmount ? this.decimalFormat(this.ocrInfos?.financialSituation?.mortgageAmount) : ''],
            mortgageEndDate: [this.ocrInfos?.financialSituation?.mortgageEndDate ? (this.ocrInfos?.financialSituation?.mortgageEndDate ? this.formatDate_(this.ocrInfos?.financialSituation?.mortgageEndDate) : '') : ''],
            mortgageLenderBank: [this.translateLenderBank(this.ocrInfos?.financialSituation?.mortgageLenderBank)],
            carLoanAmount: [this.decimalFormat(this.ocrInfos?.financialSituation?.carLoanAmount)],
            carCreditEndDate: [this.ocrInfos?.financialSituation?.carCreditEndDate ? this.formatDate_(this.ocrInfos?.financialSituation?.carCreditEndDate) : ''],
            carLoanLenderBank: [this.translateLenderBank(this.ocrInfos?.financialSituation?.carLoanLenderBank)],
            otherCredit: [this.ocrInfos?.financialSituation?.otherCredit, Validators.required],
            otherCreditAmount: [this.decimalFormat(this.ocrInfos?.financialSituation?.otherCreditAmount)],
            rentCredit: [this.ocrInfos?.financialSituation?.rentCredit],
            rentCreditAmount: [this.decimalFormat(this.ocrInfos?.financialSituation?.rentCreditAmount)],
            savingsAccount: [this.ocrInfos?.financialSituation?.savingsAccount],
            savingsAccountAmount: [this.decimalFormat(this.ocrInfos?.financialSituation?.savingsAccountAmount)],
            otherIncome: [this.ocrInfos?.financialSituation?.otherIncome, Validators.required],
            otherCreditEndDate: [this.ocrInfos?.financialSituation?.otherCreditEndDate ? this.formatDate_(this.ocrInfos?.financialSituation?.otherCreditEndDate) : ''],
            bankLenderCreditOther: [this.translateLenderBank(this.ocrInfos?.financialSituation?.bankLenderCreditOther)],
        });

        // test if uploaded doc has driving licence or CNI
        this.folderVerificationService.documents$
            .pipe(
                take(1),
                map(docs => {
                    const hasDL = docs.some(d => d.documentsGender === 'DRIVING_LICENSE');
                    const hasCNI = docs.some(d =>
                        ['FRONT_IDENTITY_CARD', 'BACK_IDENTITY_CARD'].includes(d.documentsGender)
                    );

                    if (hasDL) return 'PERMIS';
                    if (hasCNI) return 'CNI';
                    return '';
                })
            )
            .subscribe(value => {
                this.form.get('cardType')?.setValue(value);
            });

        this.clientInfoForm.emit(this.form);

        this.filteredOptions = this.form.get('wilaya').valueChanges
            .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value),
                map(name => name ? this._filter(name.toString()) : this.wilayasList.slice())
            );
        this.filteredBirthWilayas = this.form.get('birthWilaya').valueChanges
            .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value),
                map(name => name ? this.birthWilayaFilter(name.toString()) : this.birthWilayasList.slice())
            );

        this.filteredEmployerWilaya = this.form.get('employerWilaya').valueChanges
            .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value),
                map(name => name ? this._filterEmplyer(name.toString()) : this.employerWilayasList.slice())
            );

        this.activityDomainOptions = this.form.get('activityDomain').valueChanges
            .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value),
                map(name => name ? this.activityDomainfilter(name.toString()) : ActivityDomainList.slice())
            );

        this.activityDomainTwoOptions = this.form.get('activityDomainTwo').valueChanges
            .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value),
                map(name => name ? this.activityDomainTwofilter(name.toString()) : ActivityDomains.slice())
            );

        this.bankLenderCreditOtherOptions = this.form.get('bankLenderCreditOther').valueChanges
            .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value),
                map(name => name ? this.bankLenderCreditOtherFilter(name.toString()) : BANK_LENDER.slice())
            );

        this.carLoanLenderBankOptions = this.form.get('carLoanLenderBank').valueChanges
            .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value),
                map(name => name ? this.bankLenderCreditOtherFilter(name.toString()) : BANK_LENDER.slice())
            );

        this.mortgageLenderBankOptions = this.form.get('mortgageLenderBank').valueChanges
            .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value),
                map(name => name ? this.bankLenderCreditOtherFilter(name.toString()) : BANK_LENDER.slice())
            );

        this.professionOptions = this.form.get('profession').valueChanges
            .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value),
                map(name => name ? this.professionfilter(name.toString()) : this.professions.slice())
            );

        this.form.valueChanges.subscribe(() => {

            this.socialClientCategory = this.form.get('socialClientCategory').value;
            this.professionalClientCategory = this.form.get('professionalClientCategory').value;

            if (this.form.get('savingsAccount').value === true) {

            }

            this.clientInfoForm.emit(this.form);

        });

        // Validators Manipulation Before Any Change

        if (this.form.get('savingsAccount').value === false) {
            this.form.get('savingsAccountAmount').clearValidators();
            this.form.get('savingsAccountAmount').updateValueAndValidity({onlySelf: true});
        }

        if (this.form.get('rentCredit').value === false) {
            this.form.get('rentCreditAmount').clearValidators();
            this.form.get('rentCreditAmount').updateValueAndValidity({onlySelf: true});
        }

        if (this.form.get('otherCredit').value === false) {
            this.form.get('bankLenderCreditOther').clearValidators();
            this.form.get('bankLenderCreditOther').updateValueAndValidity({onlySelf: true});

            this.form.get('otherCreditEndDate').clearValidators();
            this.form.get('otherCreditEndDate').updateValueAndValidity({onlySelf: true});

            this.form.get('otherCreditAmount').clearValidators();
            this.form.get('otherCreditAmount').updateValueAndValidity({onlySelf: true});

        }

        switch (this.form.get('professionalClientCategory').value) {
            case 'EMPLOYEE' : {
                this.form.get('dateRetraite').clearValidators();
                this.form.get('dateRetraite').updateValueAndValidity({onlySelf: true});
                this.form.get('netSalaryRENA').clearValidators();
                this.form.get('netSalaryRENA').updateValueAndValidity({onlySelf: true});
                break;
            }
            case 'RETRIED' : {
                this.form.get('montant_net').clearValidators();
                this.form.get('montant_net').updateValueAndValidity({onlySelf: true});
                break;
            }

        }

        switch (this.form.get('socialClientCategory').value) {
            case 'SINGLE' : {
                this.form.get('dependentChild').clearValidators();
                this.form.get('dependentChild').updateValueAndValidity({onlySelf: true});
                break;
            }
            case 'MARRIED' : {
                this.form.get('maidenName').clearValidators();
                this.form.get('maidenName').updateValueAndValidity({onlySelf: true});
                this.form.get('maidenNameInArabic').clearValidators();
                this.form.get('maidenNameInArabic').updateValueAndValidity({onlySelf: true});
                this.form.get('partnerLastName').clearValidators();
                this.form.get('partnerLastName').updateValueAndValidity({onlySelf: true});

                break;
            }
            case 'DIVORCE' : {
                this.form.get('maidenName').clearValidators();
                this.form.get('maidenName').updateValueAndValidity({onlySelf: true});
                this.form.get('maidenNameInArabic').clearValidators();
                this.form.get('maidenNameInArabic').updateValueAndValidity({onlySelf: true});
                break;
            }
            case 'WIDOWER' : {
                this.form.get('maidenName').clearValidators();
                this.form.get('maidenName').updateValueAndValidity({onlySelf: true});
                this.form.get('maidenNameInArabic').clearValidators();
                this.form.get('maidenNameInArabic').updateValueAndValidity({onlySelf: true});
                break;
            }

        }

        if (this.form.get('gender').value === 'Male') {
            this.form.get('maidenName').clearValidators();
            this.form.get('maidenName').updateValueAndValidity({onlySelf: true});
            this.form.get('maidenNameInArabic').clearValidators();
            this.form.get('maidenNameInArabic').updateValueAndValidity({onlySelf: true});
            this.form.get('partnerLastName').clearValidators();
            this.form.get('partnerLastName').updateValueAndValidity({onlySelf: true});
        }


        // Validators Manipulation After Changes

        this.form.get('savingsAccount').valueChanges.subscribe(change => {
            if (change === false) {
                this.form.get('savingsAccountAmount').clearValidators();
                this.form.get('savingsAccountAmount').updateValueAndValidity({onlySelf: true});
            }
        });

        this.form.get('rentCredit').valueChanges.subscribe(change => {
            if (change === false) {
                this.form.get('rentCreditAmount').clearValidators();
                this.form.get('rentCreditAmount').updateValueAndValidity({onlySelf: true});
            }
        });

        this.form.get('otherCredit').valueChanges.subscribe(change => {
            if (change === false) {
                this.form.get('bankLenderCreditOther').clearValidators();
                this.form.get('bankLenderCreditOther').updateValueAndValidity({onlySelf: true});

                this.form.get('otherCreditEndDate').clearValidators();
                this.form.get('otherCreditEndDate').updateValueAndValidity({onlySelf: true});

                this.form.get('otherCreditAmount').clearValidators();
                this.form.get('otherCreditAmount').updateValueAndValidity({onlySelf: true});
            }
        });

        this.form.get('professionalClientCategory').valueChanges.subscribe(Category => {
            if (Category === 'EMPLOYEE') {
                this.form.get('dateRetraite').clearValidators();
                this.form.get('dateRetraite').updateValueAndValidity({onlySelf: true});
                this.form.get('netSalaryRENA').clearValidators();
                this.form.get('netSalaryRENA').updateValueAndValidity({onlySelf: true});
            }

            if (Category === 'RETRIED') {
                this.form.get('montant_net').clearValidators();
                this.form.get('montant_net').updateValueAndValidity({onlySelf: true});
            }
        });


        this.form.get('socialClientCategory').valueChanges.subscribe(Category => {
            if (Category === 'SINGLE') {
                this.form.get('dependentChild').clearValidators();
                this.form.get('dependentChild').updateValueAndValidity({onlySelf: true});
            }
            if (Category !== 'MARRIED' && Category !== 'WIDOWER') {
                this.form.get('maidenName').clearValidators();
                this.form.get('maidenName').updateValueAndValidity({onlySelf: true});
                this.form.get('maidenNameInArabic').clearValidators();
                this.form.get('maidenNameInArabic').updateValueAndValidity({onlySelf: true});
            }
        });

        this.form.get('gender').valueChanges.subscribe(Category => {
            if (Category === 'Male') {
                this.form.get('maidenName').clearValidators();
                this.form.get('maidenName').updateValueAndValidity({onlySelf: true});
                this.form.get('maidenNameInArabic').clearValidators();
                this.form.get('maidenNameInArabic').updateValueAndValidity({onlySelf: true});
                this.form.get('partnerLastName').clearValidators();
                this.form.get('partnerLastName').updateValueAndValidity({onlySelf: true});
            }
        });

    }

    ngAfterViewInit() {
        const inputs = document.querySelectorAll('.input-arabic');
        inputs.forEach((input, index) => {
            let prevValue = input as HTMLInputElement
            this.prevValue2[index] = prevValue.value
            const keyboardClass = '.simple-keyboard' + `${this.form.get('gender').value === 'Female' && (this.socialClientCategory === 'MARRIED' || this.socialClientCategory === 'WIDOWER') ? index : index + 1}`
            const keyboard = new Keyboard(keyboardClass, {
                onChange: input => this.onChange(input, index),
                onKeyPress: button => this.onKeyPress(button, index),
                ...layout,
                rtl: true
            });
            this.keyboards.push(keyboard);
            input.addEventListener('input', (event: any) => {
                const targetInput = event.target as HTMLInputElement;
                // Update the corresponding keyboard input without replacing
                this.keyboards[index].setInput(targetInput.value);
            });
        });
    }

    onChange = (input: string, index: number) => {
        const inputs = document.querySelectorAll('.input-arabic');
        const targetInput = inputs[index] as HTMLInputElement;
        let length = this.prevValue2[index].length
        const value = targetInput.value.slice(0, length);
        targetInput.value = value + input;
    };

    onKeyPress = (button: string, index: number) => {
        const inputs = document.querySelectorAll('.input-arabic');
        const targetInput = inputs[index] as HTMLInputElement;
        if (button === "{bksp}") {
            targetInput.value = targetInput.value.slice(0, -1);
            if (targetInput.value == '') {
                this.prevValue2[index] = ''
            }
        }
        if (button === "{shift}" || button === "{lock}") {
            this.handleShift(index);
        }
    };

    handleShift = (index: number) => {
        let currentLayout = this.keyboards[index].options.layoutName;
        let shiftToggle = currentLayout === "default" ? "shift" : "default";

        this.keyboards[index].setOptions({
            layoutName: shiftToggle
        });
    };

    displayProfession(profession: string): string {
        return this.professions.find(item => item.value === profession)?.name ?? profession;
    }

    // check if maidenName should be required
    isMaidenNameRequired() {
        const gender = this.form.get('gender')?.value;
        // Return true if female and married, false otherwise
        return (gender === 'Female') && (gender !== null) && (this.socialClientCategory === 'MARRIED' || this.socialClientCategory === 'WIDOWER');
    }

    // check if maidenName should be required
    isDependentChildRequired() {
        // Return true if not SINGLE, false otherwise
        return this.socialClientCategory !== 'SINGLE';
    }

    // check if maidenName should be required
    isPartnerLastNameRequired() {
        // Return true if female married, false otherwise
        return this.socialClientCategory === 'MARRIED' && this.form.get('gender').value === 'Female';
    }

    // check if date of Retirement should be required
    isDateOfRetirementRequired() {
        // Return true if RETRIED or MILITARY_RETIRED , false otherwise
        return this.professionalClientCategory === 'RETRIED' || this.professionalClientCategory === 'MILITARY_RETIRED';
    }

    // check if ActivityDomain , ActivityDomainTwo, profession and recruitmentDate should be required
    isActivityDomainRequired() {
        return this.professionalClientCategory !== 'RETRIED' && this.professionalClientCategory !== 'MILITARY_RETIRED';
    }

    decimalFormat(value) {
        if (value) {
            const v_ = value.toString().replace(' ', '');
            return this.decimalFormatPipe.transform(v_);
        } else {
            return value;
        }
    }

    formatDate(input) {
        return new Date(input.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'));
    }


    // format date from dd-mm-yy to EEE MMM dd yyyy HH:mm:ss 'GMT'ZZZZZ (zzzz) format
    formatDate_(inputDateString) {
        if (inputDateString) {
            const [day, month, year] = inputDateString.split('-');
            return new Date(Number(year), Number(month) - 1, Number(day));
        } else {
            return null; // Return null instead of an empty string
        }
    }

    getWilayaTowns(event) {

        this.selectedWilaya = event.option.value;

        this.form.get('commune').reset();

        if (this.form.controls.wilaya.dirty) {
            this.form.controls.commune.enable();
        }

        this.getTowns(this.wilayasList.filter(value => {
            if (value.value === this.selectedWilaya) {
                return value;
            }
        })[0].id);
    }

    private townFilter(name: string): Town[] {
        const filterValue = name.toLowerCase();
        return this.towns.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

    private _filter(name: string): Wilaya[] {
        const filterValue = name.toLowerCase();
        return this.wilayasList.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

    private birthWilayaFilter(name: string): Wilaya[] {
        const filterValue = name.toLowerCase();
        return this.birthWilayasList.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

    private _filterEmplyer(name: string): Wilaya[] {
        const filterValue = name.toLowerCase();
        return this.employerWilayasList.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

    private activityDomainfilter(name: string): List[] {
        const filterValue = name.toLowerCase();
        return ActivityDomainList.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

    private activityDomainTwofilter(name: string): List[] {
        const filterValue = name.toLowerCase();
        return ActivityDomains.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

    private bankLenderCreditOtherFilter(name: string): List[] {
        const filterValue = name.toLowerCase();
        return BANK_LENDER.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

    private professionfilter(name: string): List[] {
        const filterValue = name.toLowerCase();
        return this.professions.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

    translateLenderBank(value: string) {
        if (value === 'NONE') {
            return '';
        }
        return BANK_LENDER.find(option => option.value === value)?.name;
    }

    getWilayaTownsDefault(selectedWilaya) {

        if (this.selectedWilaya) {

            if (this.form.controls.wilaya.dirty) {
                this.form.controls.commune.enable();
            }

            this.getTowns(this.wilayasList.filter(value => {
                if (value.value == selectedWilaya) {
                    return value;
                }
            })[0].id);
        }
    }

    getTowns(wilayaId) {
        this.wilayaService.getTownsByWilayaId(wilayaId).subscribe(res => {
            this.towns = res;
            this.townsSubject$.next(res);
            this.townFilteredOptions = this.form.get('commune').valueChanges
                .pipe(
                    startWith(''),
                    map(value => typeof value === 'string' ? value : value),
                    map(name => name ? this.townFilter(name.toString()) : this.towns.slice())
                );
        });
    }

    forbiddenTownsValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            if (this.towns.length > 0) {// below findIndex will check if control.value is equal to one of our options or not
                const index = this.towns.findIndex(town => {
                    return (new RegExp('\^' + town.name + '\$')).test(control.value);
                });
                return index < 0 ? {forbiddentowns: {value: control.value}} : null;
            }
        };
    }

    filteredbirthWilayaExecuted() {
        this.filteredBirthWilayas = this.form.get('birthWilaya').valueChanges
            .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value),
                map(name => name ? this.birthWilayaFilter(name.toString()) : this.birthWilayasList.slice())
            );
    }

    selectBirthWilaya(name: string) {
        const selectedBirthWilaya = this.birthWilayasList.find((c) => c.value === name);
        this.form
            .get('birthWilaya')
            .setValue(selectedBirthWilaya?.value);
    }
}

const ActivityDomainList = [
    {name: 'Publique', value: 'PUBLIC'},
    {name: 'Privée', value: 'PRIVATE'},
    {name: 'Non concerné', value: 'NOT_CONCERNED'}
];

const ActivityDomains = [
    {value: 'AGRICULTURE', name: 'Agriculture Chasse Services Annexes'},
    {value: 'FORESTRY', name: 'Sylviculture Exploitation Forestière Services Annexes'},
    {value: 'FISHING', name: 'Pêche Aquaculture'},
    {value: 'COAL_EXTRACTION', name: 'Extraction de Houille de Lignite et de Tourbe'},
    {value: 'HYDROCARBON_EXTRACTION', name: 'Extraction d\'Hydrocarbures Services Annexes'},
    {value: 'URANIUM_EXTRACTION', name: 'Extraction de Minerais d\'Uranium'},
    {value: 'METAL_ORE_EXTRACTION', name: 'Extraction de Minerais Métalliques'},
    {value: 'OTHER_EXTRACTION', name: 'Autres Industries Extractives'},
    {value: 'FOOD_INDUSTRIES', name: 'Industries Alimentaires'},
    {value: 'TOBACCO', name: 'Industrie du Tabac'},
    {value: 'TEXTILE', name: 'Industrie Textile'},
    {value: 'CLOTHING', name: 'Industrie de l\'Habillement et des Fourrures'},
    {value: 'LEATHER', name: 'Industrie du Cuir et de la Chaussure'},
    {value: 'WOOD', name: 'Travail du Bois et Fabrication d\'Articles en Bois'},
    {value: 'PAPER', name: 'Industrie du Papier et du Carton'},
    {value: 'PRINTING', name: 'Édition Imprimerie Reproduction'},
    {value: 'REFINING', name: 'Cokéfaction Raffinage Industries Nucléaires'},
    {value: 'CHEMICAL', name: 'Industrie Chimique'},
    {value: 'RUBBER', name: 'Industrie de Caoutchouc et des Tiques'},
    {value: 'NON_METALLIC_MINERALS', name: 'Fabrication d\'Autres Produits Minéraux Non Métalliques'},
    {value: 'METALLURGY', name: 'Métallurgie'},
    {value: 'METAL_PRODUCTS', name: 'Travail des Métaux'},
    {value: 'MACHINERY', name: 'Fabrication de Machines et Équipements'},
    {value: 'OFFICE_MACHINERY', name: 'Fabrication de Machines de Bureau et de Matériel Informatique'},
    {value: 'ELECTRICAL_MACHINERY', name: 'Fabrication de Machines et Appareils Électriques'},
    {value: 'RADIO_TV_COMMUNICATION', name: 'Fabrication d\'Équipements de Radio Télévision et Communication'},
    {value: 'MEDICAL_PRECISION', name: 'Fabrication d\'Instruments Médicaux de Précision d\'Optique et d\'Horlogerie'},
    {value: 'AUTOMOBILES', name: 'Industrie Automobile'},
    {value: 'TRANSPORT_EQUIPMENT', name: 'Fabrication d\'Autres Matériels de Transport'},
    {value: 'FURNITURE', name: 'Fabrication de Meubles Industries Diverses'},
    {value: 'RECYCLING', name: 'Récupération'},
    {value: 'ELECTRICITY_GAS', name: 'Production et Distribution d\'Électricité de Gaz et de Chaleur'},
    {value: 'WATER_SUPPLY', name: 'Captage Traitement et Distribution d\'Eau'},
    {value: 'CONSTRUCTION', name: 'Construction'},
    {value: 'AUTO_REPAIR', name: 'Commerce et Réparation Automobile'},
    {value: 'WHOLESALE', name: 'Commerce de Gros et Intermédiaires du Commerce'},
    {value: 'RETAIL', name: 'Commerce de Détail et Réparation d\'Articles Domestiques'},
    {value: 'HOTELS_RESTAURANTS', name: 'Hôtels et Restaurants'},
    {value: 'LAND_TRANSPORT', name: 'Transports Terrestres'},
    {value: 'WATER_TRANSPORT', name: 'Transports par Eau'},
    {value: 'AIR_TRANSPORT', name: 'Transports Aériens'},
    {value: 'TRANSPORT_AUXILIARY', name: 'Services Auxiliaires des Transports'},
    {value: 'POST_TELECOMMUNICATIONS', name: 'Postes et Télécommunications'},
    {value: 'FINANCIAL_INTERMEDIATION', name: 'Intermédiation Financière'},
    {value: 'INSURANCE', name: 'Assurance'},
    {value: 'FINANCIAL_AUXILIARY', name: 'Auxiliaires Financiers et d\'Assurance'},
    {value: 'REAL_ESTATE', name: 'Activités Immobilières'},
    {value: 'RENTAL', name: 'Location sans Opérateur'},
    {value: 'INFORMATION_TECH', name: 'Activités Informatiques'},
    {value: 'RESEARCH_DEVELOPMENT', name: 'Recherche et Développement'},
    {value: 'BUSINESS_SERVICES', name: 'Services Fournis Principalement aux Entreprises'},
    {value: 'PUBLIC_ADMINISTRATION', name: 'Administration Publique'},
    {value: 'EDUCATION', name: 'Éducation'},
    {value: 'HEALTH_SOCIAL', name: 'Santé et Action Sociale'},
    {value: 'WASTE_MANAGEMENT', name: 'Assainissement Voirie et Gestion des Déchets'},
    {value: 'ASSOCIATIONS', name: 'Activités Associatives'},
    {value: 'CULTURAL_SPORTS', name: 'Activités Récréatives Culturelles et Sportives'},
    {value: 'PERSONAL_SERVICES', name: 'Services Personnels'},
    {value: 'DOMESTIC_SERVICES', name: 'Services Domestiques'},
    {value: 'EXTRA_TERRITORIAL', name: 'Activités Extra Territoriales'},
    {value: 'INDIVIDUAL', name: 'Particulier'}
];

